<template>
  <div class="card_manage_wrap">
    <common-header show-search @search="search" placeholder="请输入卡名称">
      <el-button type="primary" size="medium" @click="toBatchAdd">批量生成卡片</el-button>
    </common-header>
    <el-table stripe :data="dataList" :height="`${windowHeight - 210}px`" border style="width: 100%">
      <el-table-column label="卡名称" prop="cardName" show-overflow-tooltip></el-table-column>
      <el-table-column label="卡积分" prop="point" show-overflow-tooltip></el-table-column>
      <el-table-column label="生成张数" prop="buildNum" show-overflow-tooltip></el-table-column>
      <el-table-column label="已使用张数" prop="useCount" show-overflow-tooltip></el-table-column>
      <el-table-column label="操作人" prop="buildUser" show-overflow-tooltip></el-table-column>
      <el-table-column label="时间" align="center">
        <template slot-scope="scope">
          <span>{{scope.row.buildTime | timeFormat}}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <el-button type="text" @click="toCardInfo(scope.row.id,scope.row.templateId)">查看卡片</el-button>
          <el-button type="text" @click="toUseRecord(scope.row.id)">使用记录</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination class="pagination-container" @size-change="handleSizeChange" @current-change="handleCurrentChange"
      :current-page.sync="listQuery.pageNo" :page-sizes="[10, 20, 30, 50]" :page-size="listQuery.pageSize"
      layout="total, sizes, prev, pager, next, jumper" :total="total">
    </el-pagination>
  </div>
</template>

<script>
  import windowResize from "@/mixins/windowResize";
  import {getIntegralCardBatchPageList} from '@/api/integralBank';
  import CommonHeader from '@/components/CommonHeader';

  export default {
    name: "cardManageList",
    components: {CommonHeader},
    data() {
      return {
        dataList: [],
        listQuery: {
          pageNo: 1,
          pageSize: 20,
          cardName: ''
        },
        total: null
      }
    },
    filters: {
      timeFormat(time) {
        return time ? time.substring(0, 19) : "--";
      },
    },
    mixins: [windowResize],
      activated(){
       this.getIntegralCardBatchPageList();
    },
    created() {
      this.getIntegralCardBatchPageList();
    },
    methods: {
      toBatchAdd() {
        this.$router.push({path: 'cardBatchAdd'})
      },
      toCardInfo(batchId,templateId) {
        this.$router.push({path: 'cardManageInfo', query: {batchId: batchId,templateId:templateId}})
      },
      toUseRecord(batchId) {
        this.$router.push({path: 'cardUseRecord', query: {batchId: batchId}})
      },
      search(val) {
        this.listQuery.pageNo = 1;
        this.listQuery.cardName = val;
        this.getIntegralCardBatchPageList();
      },
      getIntegralCardBatchPageList() {
        getIntegralCardBatchPageList(this.listQuery).then(res => res.data).then(data => {
          if (data.code === 200 && data.result) {
            this.dataList = data.data.dataList;
            this.total = data.data.pagination.total;
          }
        });
      },
      //切换码数
      handleSizeChange(val) {
        this.listQuery.pageNo = 1;
        this.listQuery.pageSize = val;
        this.getIntegralCardBatchPageList();
      },
      //切换页数
      handleCurrentChange(val) {
        this.listQuery.pageNo = val;
        this.getIntegralCardBatchPageList();
      },
    }
  }
</script>

<style lang="scss" scoped>
  .card_manage_wrap{
    padding: 12px;
  }
</style>



// WEBPACK FOOTER //
// src/views/integralBank/cardManageList.vue